import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as closingService from '../../services/closingService';

export const fetchDailyClosing = createAsyncThunk(
  'closing/fetchDailyClosing',
  async (date: string) => {
    const response = await closingService.getDailyClosing(date);
    return response;
  }
);

export const submitClosing = createAsyncThunk(
  'closing/submitClosing',
  async (closingData: any) => {
    const response = await closingService.createClosing(closingData);
    return response;
  }
);

const closingSlice = createSlice({
  name: 'closing',
  initialState: {
    dailyClosing: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    resetClosingState(state) {
      state.dailyClosing = null;
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyClosing.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchDailyClosing.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.dailyClosing = action.payload;
      })
      .addCase(fetchDailyClosing.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(submitClosing.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(submitClosing.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(submitClosing.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
});

export const { resetClosingState } = closingSlice.actions;

// Selectors
export const selectDailyClosing = (state: any) => state.closing.dailyClosing;
export const selectStatus = (state: any) => state.closing.status;
export const selectError = (state: any) => state.closing.error;

export default closingSlice.reducer;